// The languages the web UI speaks (D70). A language is named in itself, never by a flag: a
// language is not a country. `intl` is the tag every Intl formatter gets; English is British
// (24-hour clock, day before month), as the UI's spelling is.

export const LOCALES = ["en", "fr", "es"] as const;

export type Locale = (typeof LOCALES)[number];

interface LocaleInfo {
  /** The language's own name, for the switcher. */
  name: string;
  intl: string;
  /** How a US-dollar amount names its currency: "$" in English, "$US" / "US$" elsewhere. */
  currencyDisplay: "narrowSymbol" | "symbol";
}

export const LOCALE_INFO: Record<Locale, LocaleInfo> = {
  en: { name: "English", intl: "en-GB", currencyDisplay: "narrowSymbol" },
  fr: { name: "Français", intl: "fr-FR", currencyDisplay: "symbol" },
  es: { name: "Español", intl: "es-ES", currencyDisplay: "symbol" },
};

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}

/** The first of the browser's languages we speak ("fr-CA" → fr), else English. */
export function negotiate(languages: readonly string[]): Locale {
  for (const tag of languages) {
    const base = tag.toLowerCase().split("-")[0];
    if (isLocale(base)) return base;
  }
  return "en";
}
